import { useQuery } from "react-query";
import { internalApi } from "@circle-react/helpers/urlHelpers";
import { useTipTapEditorContext } from "@circle-react-uikit/TipTap/TipTapEditorContext";
import { useBlockEditorContext } from "@circle-react-uikit/TipTapBlockEditor";
import { useOpenChatRoomUuid } from "./useOpenChatRoomUuid";

interface Props {
  command: (item: any) => void;
  href: string;
}

interface UnfurlMessageLink {
  is_private_message?: boolean;
  sgid: string;
  type: string;
}

export const ChatMessagePaste = ({ href, command }: Props): any => {
  const tiptapEditorContext = useTipTapEditorContext();
  const tiptapBlockEditorContext = useBlockEditorContext();
  const { addToLocalSgidToObjectMap } =
    tiptapEditorContext || tiptapBlockEditorContext;

  const { chatRoomUuid } = useOpenChatRoomUuid();

  useQuery(
    internalApi.richTextFields.unfurlURLs({
      params: { urls: [href], open_chat_room_uuid: chatRoomUuid },
    }),
    {
      initialData: [],
      onSuccess: data => {
        const chatMessageLink: UnfurlMessageLink = data?.[0] ?? {
          type: "",
          sgid: "",
        };
        if (chatMessageLink.type) {
          addToLocalSgidToObjectMap({
            sgid: chatMessageLink.sgid,
            object: chatMessageLink,
          });
          command(chatMessageLink.sgid);
        }
      },
    },
  );

  return null;
};

ChatMessagePaste.displayName = "ChatMessagePaste";
